// extracted by mini-css-extract-plugin
export var btn = "P_mB D_vJ D_vv d_bz d_bP d_bD d_dw";
export var full = "P_wW d_w d_H";
export var hoverStyle = "P_mF";
export var zoom = "P_mG";